import React, { useEffect } from "react";
import { Route, useLocation, useNavigate } from "react-router-dom";
import { Wrapper } from "../Components/Utils/roles";

import MainTask from "../Views/Web/Task/TaskMain";
import { AllTasksMain, AllTaskIndex, CreateAllTasks, EditAllTasks, ViewAllTask } from "../Views/Web/Task/MyTasks";
import { MyTasksMain, MyTaskIndex, CreateMyTasks, EditMyTasks, ViewMyTask } from "../Views/Web/Task/AllTasks";

function TaskRoutes() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (
            location.pathname === "/tasks" ||
            location.pathname === "/tasks/") {
            navigate("/page-not-found")
        }
    }, [location])
    return (
        <Route path="tasks" element={<MainTask />}>
            <Route path="all-tasks" element={<AllTasksMain />} >
                <Route index element={<Wrapper permissionKey={true} Component={AllTaskIndex} />} />
                <Route path="create" element={<Wrapper permissionKey={true} Component={CreateAllTasks} />} />
                <Route path="edit/:allTaskEditId" element={<Wrapper permissionKey={true} Component={EditAllTasks} />} />
                <Route path="view/:allTaskViewId" element={<Wrapper permissionKey={true} Component={ViewAllTask} />} />
            </Route>
            <Route path="my-tasks" element={<MyTasksMain />} >
                <Route index element={<Wrapper permissionKey={true} Component={MyTaskIndex} />} />
                <Route path="create" element={<Wrapper permissionKey={true} Component={CreateMyTasks} />} />
                <Route path="edit/:myTaskEditId" element={<Wrapper permissionKey={true} Component={EditMyTasks} />} />
                <Route path="view/:myTaskViewId" element={<Wrapper permissionKey={true} Component={ViewMyTask} />} />
            </Route>
        </Route>
    )
}

export default TaskRoutes;